import React from 'react';

import { connect } from 'react-redux';

import { liveCheckSelectors } from 'wanderu-ducks-live-check';
import {
    tripSummaryActions,
    liveCheckItinerary,
} from 'wanderu-ducks-search';
import {
    tripActions,
    tripSelectors,
} from 'wanderu-ducks-trips';

import FareClass from '../../components/SearchResult/FareClass/FareClass';

function FareClassContainer(props) {
    return (
        <FareClass {...props} />
    );
}

function mapStateToProps(state, ownProps) {
    const { tripId, seats, wheelchairs } = ownProps;
    const lcParams = {
        fareVersion: 'v2',
        seats,
        tripId,
        wheelchairs,
    };

    const { selectedFare } = tripSelectors.selectTripData(state, tripId) || {};
    const {
        tripData: {
            selected_fare: initialSelectedFare,
        } = {},
    } = liveCheckSelectors.selectTripLiveCheck(state, lcParams) || {};

    return {
        selectedFareCode: selectedFare || initialSelectedFare,
    };
}

const mapDispatchToProps = {
    performLiveCheck: liveCheckItinerary,
    setFareClass: tripSummaryActions.setFareClass,
    updateTrip: tripActions.updateTrip,
};

export {
    FareClassContainer,
};
export default connect(mapStateToProps, mapDispatchToProps)(FareClassContainer);
